module.exports = __webpack_public_path__ + "img/sx.1ae5d248.png";